export const APPLICABLE_REPAYMENT_TERMS = 'personalLoans/referenceData/transition/'
export const GET_APPLICABLE_REPAYMENT_TERMS = APPLICABLE_REPAYMENT_TERMS + 'fetchingApplicableTerms';
export const GET_APPLICABLE_REPAYMENT_TERMS_SUCCESS = APPLICABLE_REPAYMENT_TERMS + 'success';
export const GET_APPLICABLE_REPAYMENT_TERMS_FAILURE = APPLICABLE_REPAYMENT_TERMS + 'failure';

export const getApplicableRepaymentTerms = () => ({ type: GET_APPLICABLE_REPAYMENT_TERMS });
export const getApplicableRepaymentTermsSuccess = (value) => ({ type: GET_APPLICABLE_REPAYMENT_TERMS_SUCCESS, value });
export const getApplicableRepaymentTermsFailure = (error) => ({ type: GET_APPLICABLE_REPAYMENT_TERMS_FAILURE, error });